export default "__VITE_ASSET__D1m3Zc5$__"